import {
  GET_ORDERS_STARTED,
  GET_ORDERS_SUCCEED,
  GET_ORDERS_FAILED
} from "../actions/types/ordersActionTypes";

export default function orderReducer(
  state = { pendingOrders: [], readyOrders: [] },
  action
) {
  switch (action.type) {
    case GET_ORDERS_SUCCEED: {
      state.pendingOrders = [...action.data.pendingOrders];
      state.readyOrders = [...action.data.readyOrders];

      return Object.assign({}, state);
    }
    case GET_ORDERS_STARTED:
    case GET_ORDERS_FAILED: {
      state.pendingOrders = [];
      state.readyOrders = [];
      return Object.assign({}, state);
    }
    default: {
      return Object.assign({}, state);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/orderReducer.js